import Parse from 'parse/dist/parse.min.js';

// Your Parse initialization configuration goes here
const PARSE_APPLICATION_ID = '5ztPwNfiEsECGiMa5fa8qEnVIh6qSKSqZQbjHa9T';
const PARSE_HOST_URL = 'https://parseapi.back4app.com/';
const PARSE_JAVASCRIPT_KEY = 'Nm6SKh3i2Po2XLVDTY6uQvmj4adjcLVgoo01Xjve';
Parse.initialize(PARSE_APPLICATION_ID, PARSE_JAVASCRIPT_KEY);
Parse.serverURL = PARSE_HOST_URL;

export default Parse;